import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomsOfficeSelectComponent } from './customs-office-select.component';
import { TranslocoModule } from '@jsverse/transloco';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormErrorModule, SelectModule } from '@eg/ui';

@NgModule({
  declarations: [CustomsOfficeSelectComponent],
  imports: [CommonModule, SelectModule, TranslocoModule, FlexLayoutModule, FormErrorModule],
  exports: [CustomsOfficeSelectComponent],
})
export class CustomsOfficeModule {}
